export const metas = {
  data() {
    return {
      alternates: [],
      htmlTitle: "Wegow",
      canonical: "",
      lang: ""
    };
  },
  methods: {
    setMetasHtml(data) {
      let structuredData = {
        "@context": "http://schema.org",
        "@type": "Organization",
        "url": "https://www.wegow.com",
        "logo": "https://cdn.wegow.com/no-delete/wegow/wegow-conciertos.svg",
        "address": "Miguel Ángel 13, 3º 28010 Madrid",
        "email": "info@wegow.es",
        "contactPoint": {
          "@type": "ContactPoint",
          "contactType": "customer service"
        }
      };
      // Add/update noIndex
      const existingMetaTags = document.querySelectorAll(
        'meta[name="robots"][content="noindex"]'
      );
      if (data.noIndex && existingMetaTags.length === 0) {
        const metaTag = document.createElement("meta");
        metaTag.setAttribute("name", "robots");
        metaTag.setAttribute("content", "noindex");
        document.head.appendChild(metaTag);
      } else if (!data.noIndex && existingMetaTags.length > 0) {
        existingMetaTags.forEach(metaTag => {
          metaTag.parentNode.removeChild(metaTag);
        });
      }

      // Add/update title
      if (data.title) {
        document.title = data.title;
      }

      // Add/update description
      const existingMeta = document.querySelector('meta[name="description"]');
      if (data.description) {
        if (existingMeta) {
          existingMeta.content = data.description;
        } else {
          const newMeta = document.createElement("meta");
          newMeta.name = "description";
          newMeta.content = data.description;
          document.head.appendChild(newMeta);
        }
      } else if (existingMeta) {
        existingMeta.parentNode.removeChild(existingMeta);
      }
      let script = document.createElement("script");
      script.type = "application/ld+json";
      script.innerHTML = JSON.stringify(structuredData);
      document.head.appendChild(script);
    },
    setOpenGraph(meta) {
      let metaTag = document.createElement("meta");
      metaTag.setAttribute("property", meta.property);
      metaTag.content = meta.content;
      document.head.appendChild(metaTag);
    },
    setCanonical(route = {}) {
      let pathname = window.location.pathname;
      if (route.path) {
        pathname = route.path;
      }
      var canonicalLink = document.querySelector("link[rel='canonical']");
      if (canonicalLink) {
        canonicalLink.href = window.location.origin + pathname;
      } else {
        var linkTag = document.createElement("link");
        linkTag.setAttribute("rel", "canonical");
        linkTag.setAttribute("href", window.location.origin + pathname);
        document.head.appendChild(linkTag);
      }
    }
  }
};
